import React, { ReactNode } from 'react'
import * as styled from './styles'

interface Props {
  to: string,
  children: ReactNode
  "data-testid": string
}
const NavLink = (props: Props) => {
  const {to, children} = props;
  const testId = props["data-testid"]
  return (
    <styled.ListItem>
      <styled.Link to={to} data-testid={testId}>
        {children}
      </styled.Link>
    </styled.ListItem>
  )
}

export default NavLink